import React from 'react';
import dollarSignMonitor from 'src/assets/images/dollar-sign-monitor.svg';
import recurringCalendar from 'src/assets/images/recurring-calendar.svg';
import sellDashboard from 'src/assets/images/sell-dashboard.svg';
import planningDetails from 'src/assets/images/planning-details.svg';
import config from 'src/config/config';
import If from 'src/components/Shared/If/If';
import ConfirmationExitBox from '../../ConfirmationExitBox';
import './RecurringBuyWhatsNext.scss';

export interface RecurringBuyWhatsNextProps {
  hasAPPOnly?: boolean;
  hasAPP?: boolean;
  hasRAS?: boolean;
}
export const RecurringBuyWhatsNext: React.VFC<RecurringBuyWhatsNextProps> = ({
  hasAPPOnly = false,
  hasAPP = false,
  hasRAS = false,
}) => (
  <div className="recurring-buy-whats-next-exit-container">
    <div>
      <div className="recurring-buy-whats-next-exit-heading">What's next?</div>
      <div>
        <div className="row">
          <If test={!hasRAS}>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <ConfirmationExitBox
                className={'e2e-confirm-another-trade'}
                exitLocation={`${config.url}/usis/transactions/landing`}
                heading={'Submit Another Trade'}
                id={'confirm-another-trade'}
                image={dollarSignMonitor}
                subHeading={'Transact using your T. Rowe Price accounts.'}
              />
            </div>
          </If>
          <div className="col-sm-12 col-md-4 col-lg-4">
            <ConfirmationExitBox
              className={'e2e-confirm-expand-portfolio'}
              exitLocation={`${config.url}/usis/transactions/automatic`}
              heading={'View Your Automatic Transactions'}
              id={'confirm-expand-portfolio'}
              image={recurringCalendar}
              subHeading={`Setup or manage existing recurring transactions.`}
            />
          </div>
          <If test={hasRAS}>
            <div className="col-sm-12 col-md-4 col-lg-4">
              <ConfirmationExitBox
                className={'e2e-confirm-planning-details'}
                exitLocation={`${config.url}/usis/advice/planning-details`}
                heading={'View Planning Details'}
                id={'confirm-planning-details'}
                image={planningDetails}
                subHeading={`Take a look at your overall planning details and checkout our simulation tools as well.`}
              />
            </div>
          </If>
          <div className="col-sm-12 col-md-4 col-lg-4">
            <ConfirmationExitBox
              className={'e2e-confirm-view-dashboard'}
              exitLocation={`${config.url}/usis/my-accounts/`}
              heading={'View Your Dashboard'}
              id={'confirm-view-dashboard'}
              image={sellDashboard}
              subHeading={`Review your portfolio and track how your investments are performing.`}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RecurringBuyWhatsNext;
